import React from "react";
import {Link} from "react-router-dom";
import Image from "../assets/landingpageImage.png";
import {motion} from "framer-motion";

const MainHeader = () => {
  const imageAnimate = {
    offscreen: {x: -100, opacity: 0},
    onscreen: {
      x: 0,
      opacity: 1,
      rotate: [0, 5, 0],
      transition: {
        type: "spring",
        bounce: 0.4,
        duration: 3,
      },
    },
  };

  const textAnimate = {
    offscreen: {y: 100, opacity: 0},
    onscreen: {
      y: -0,
      opacity: 1,
      transition: {
        type: "spring",
        bounce: 0.4,
        duration: 3,
      },
    },
  };

  return (
    <header className="main__header">
      <div className="container main__header-container">
        <motion.div
          className="main__header-left"
          variants={textAnimate}
          initial={"offscreen"}
          animate={"onscreen"}
        >
          <h1>Spend on Electricity the Smart Way ( Current Production ).</h1>
          <p>
            MIITA gives you the power to control your spending and save on
            electricity consumption.
          </p>
          <Link to="/spend" className="btn lg">
            Get started - it's free
          </Link>
        </motion.div>
        <div className="main__header-right">
          <motion.div
            className="main__header-image"
            variants={imageAnimate}
            initial={"offscreen"}
            animate={"onscreen"}
          >
            <img src={Image} alt="MainHeaderImage" />
          </motion.div>
        </div>
      </div>
    </header>
  );
};

export default MainHeader;
